import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/DailyInspectionReport'
const DailyInspectionReport = () => {
    return (
        <Layout
            title={'Daily Inspection Report'}
        >
            <Component />


        </Layout>
    )
}

export default DailyInspectionReport